'use client';

import { useGaJobApplyOnce } from '@hooks/useGaJobApplyOnce';

/**
 * @description Mount this once in a shared layout to emit GA4 job_apply_event after apply redirect.
 */
export const GaJobApplyBridge = () => {
  useGaJobApplyOnce();
  return null;
};
